import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const companyLogos = [
  { id: 1, src: '/assets/slider/sliders-1.png', alt: 'Slider 1' },
  { id: 2, src: '/assets/slider/sliders-2.png', alt: 'Slider 2' },
  { id: 3, src: '/assets/slider/sliders-3.png', alt: 'Slider 3' },
  { id: 4, src: '/assets/slider/sliders-4.png', alt: 'Slider 4' },
  { id: 5, src: '/assets/slider/sliders-5.png', alt: 'Slider 5' },
  { id: 6, src: '/assets/slider/sliders-6.png', alt: 'Slider 6' },
  { id: 7, src: '/assets/slider/sliders-1.png', alt: 'Slider 1' },
  { id: 8, src: '/assets/slider/sliders-2.png', alt: 'Slider 2' },
  { id: 9, src: '/assets/slider/sliders-3.png', alt: 'Slider 3' },
  { id: 10, src: '/assets/slider/sliders-4.png', alt: 'Slider 4' },
  { id: 11, src: '/assets/slider/sliders-5.png', alt: 'Slider 5' },
  { id: 12, src: '/assets/slider/sliders-6.png', alt: 'Slider 6' },
];

const CompanySection = () => {
  return (
    <div className="w-full flex flex-col items-center py-14 pb-0 bg-white">
      <div className="flex justify-center">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#2c2087] mb-4 border-b-[3px] border-[#2c2087] py-1">
          Talent Acquisition Partner
        </h2>
      </div>
      <p className="mt-2 text-center text-[#0b0914] text-base md:text-3xl py-2 px-2 md:px-8 border-2 rounded-3xl border-[#2c2087] inline-block uppercase w-[80%] md:w-auto">
        A Group of our recruitment Professionals
      </p>

      <div className="relative bg-[#191970] w-full py-8 px-6 mt-14">
        {/* Swiper Container */}
        <div className="relative mx-auto">
          <div className="mx-auto flex justify-between items-center px-4 md:px-8">
            <Swiper
              slidesPerView={5}
              spaceBetween={10}
              navigation={{
                prevEl: '.prev-btn',
                nextEl: '.next-btn',
              }}
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000 }}
              modules={[Navigation, Pagination, Autoplay]}
              breakpoints={{
                320: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
              className="h-56"
            >
              {companyLogos.map((logo) => (
                <SwiperSlide key={logo.id}>
                  <div className="flex items-center justify-center p-4 rounded-lg shadow-md">
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      className="h-40 w-auto"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Navigation Buttons */}
          <button className="prev-btn absolute left-[-25px] md:left-0 top-1/2 transform -translate-y-1/2 p-3">
            <ChevronLeft className="text-white" />
          </button>
          <button className="next-btn absolute right-[-25px] md:right-0 top-1/2 transform -translate-y-1/2 p-3">
            <ChevronRight className="text-white" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanySection;
